namespace HA.Core.HTML.Menu {
    export class Item extends Container {

        protected setClick() {
            const me = this;
            this.onClick( (e: Event) => {
                me.handleClick(e);
            });
        }

        /**
         *
         * @param e
         */
        protected handleClick(e: Event) {
            const click = this.get("click");
            if (click && click.func) {
                this.processFunction(toMap(click));
            }
        }

        protected processFunction(data: Map<any, any>) {
            const navigationService = this.getNavigationService();
            switch (data.get("func")) {
                case  "toggleApp" :
                    navigationService.toggleApp(data);
                    break;
                case  "showApp" :
                    navigationService.showApp(data);
                    break;
                case  "reloadApp" :
                    navigationService.reloadApp(data);
                    break;
                case  "service" :
                    const service = this.getService(data.get("id"));
                    service.process(data);
                    break;
                default :
                    break;
            }
        }

        /**
         *
         * @returns ItemNavigation
         */
        protected getNavigationService() {
            return this.getService("ha.service.webpage");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            if (this.get("click")) {
                this.setClick();
            }
        }
    }
}
